"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var labels_exports = {};
__export(labels_exports, {
  bpmnLabelLines: () => bpmnLabelLines,
  bpmnLabelObstacles: () => bpmnLabelObstacles,
  findBpmnLabelCollisions: () => findBpmnLabelCollisions,
  placeBpmnLabels: () => placeBpmnLabels
});
module.exports = __toCommonJS(labels_exports);
var import_geometry = require("./geometry");
const flowKey = /* @__PURE__ */ __name((edge) => `${edge.from} -> ${edge.to}`, "flowKey");
function bpmnLabelLines(edge) {
  const lines = edge.labelLines ?? [edge.label ?? ""];
  return lines.map((line) => line.trim()).filter((line) => line.length > 0);
}
__name(bpmnLabelLines, "bpmnLabelLines");
function distanceToSegment(point, from, to) {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const lengthSquared = dx * dx + dy * dy;
  const t = lengthSquared === 0 ? 0 : Math.max(0, Math.min(1, ((point.x - from.x) * dx + (point.y - from.y) * dy) / lengthSquared));
  return Math.hypot(point.x - (from.x + t * dx), point.y - (from.y + t * dy));
}
__name(distanceToSegment, "distanceToSegment");
function anchorOf(edge, position) {
  const last = edge.points.length - 2;
  const declared = edge.labelAnchor;
  if (declared !== void 0) return Math.max(0, Math.min(last, declared));
  let best = 0;
  let bestDistance = Number.POSITIVE_INFINITY;
  for (let index = 0; index + 1 < edge.points.length; index++) {
    const distance = distanceToSegment(position, edge.points[index], edge.points[index + 1]);
    if (distance < bestDistance - 1e-9) {
      bestDistance = distance;
      best = index;
    }
  }
  return best;
}
__name(anchorOf, "anchorOf");
function edgeLabels(layout) {
  const labelled = [];
  for (const edge of [...layout.edges, ...layout.messageEdges]) {
    const position = edge.labelPosition;
    if (position === void 0 || edge.points.length < 2) continue;
    const lines = bpmnLabelLines(edge);
    if (lines.length === 0) continue;
    labelled.push({
      edge,
      flow: flowKey(edge),
      label: lines.join(" "),
      lines,
      anchor: anchorOf(edge, position),
      position
    });
  }
  return labelled;
}
__name(edgeLabels, "edgeLabels");
function shapeLabelBox(shape) {
  if (shape.labelPlacement !== "below" || shape.labelLines.length === 0) return void 0;
  const width = (0, import_geometry.textBlockWidth)(shape.labelLines);
  return {
    x: shape.x + shape.width / 2 - width / 2,
    y: shape.y + shape.height + import_geometry.bpmnMetrics.labelGap,
    width,
    height: shape.labelLines.length * import_geometry.bpmnMetrics.lineHeight
  };
}
__name(shapeLabelBox, "shapeLabelBox");
function frameBorders(frame, ink) {
  return [
    { x: frame.x - ink, y: frame.y - ink, width: frame.width + 2 * ink, height: 2 * ink },
    { x: frame.x - ink, y: frame.y + frame.height - ink, width: frame.width + 2 * ink, height: 2 * ink },
    { x: frame.x - ink, y: frame.y - ink, width: 2 * ink, height: frame.height + 2 * ink },
    { x: frame.x + frame.width - ink, y: frame.y - ink, width: 2 * ink, height: frame.height + 2 * ink }
  ];
}
__name(frameBorders, "frameBorders");
function staticObstacles(layout) {
  const { edgeInk, arrowSize } = import_geometry.bpmnMetrics;
  const obstacles = [];
  for (const shape of layout.shapes) {
    obstacles.push({ kind: "shape", id: shape.id, box: shape });
    const label = shapeLabelBox(shape);
    if (label !== void 0) obstacles.push({ kind: "shapeLabel", id: shape.id, box: label });
  }
  for (const pool of layout.pools) {
    obstacles.push({
      kind: "poolHeader",
      id: pool.id,
      box: { x: pool.x, y: pool.y, width: pool.headerWidth, height: pool.height }
    });
    for (const box of frameBorders(pool, edgeInk)) {
      obstacles.push({ kind: "poolBorder", id: pool.id, box });
    }
  }
  for (const lane of layout.lanes) {
    obstacles.push({
      kind: "laneHeader",
      id: lane.id,
      box: { x: lane.x, y: lane.y, width: lane.headerWidth, height: lane.height }
    });
    if (lane.separator) {
      obstacles.push({
        kind: "laneBorder",
        id: lane.id,
        box: { x: lane.x, y: lane.y - edgeInk, width: lane.width, height: 2 * edgeInk }
      });
    }
  }
  for (const edge of [...layout.edges, ...layout.messageEdges]) {
    const id = flowKey(edge);
    for (let index = 0; index + 1 < edge.points.length; index++) {
      obstacles.push({
        kind: "flow",
        id,
        segment: index,
        box: (0, import_geometry.segmentBox)(edge.points[index], edge.points[index + 1])
      });
    }
    const head = edge.points[edge.points.length - 1];
    if (head !== void 0) obstacles.push({ kind: "arrow", id, box: (0, import_geometry.pointBox)(head, arrowSize) });
  }
  return obstacles;
}
__name(staticObstacles, "staticObstacles");
function bpmnLabelObstacles(layout) {
  const obstacles = staticObstacles(layout);
  for (const label of edgeLabels(layout)) {
    for (const box of (0, import_geometry.labelLineBoxes)(label.lines, label.position)) {
      obstacles.push({ kind: "flowLabel", id: label.flow, box });
    }
  }
  return obstacles;
}
__name(bpmnLabelObstacles, "bpmnLabelObstacles");
function alongOwnLine(ends, horizontal) {
  if (!horizontal) return () => false;
  const { edgeInk } = import_geometry.bpmnMetrics;
  const y = (ends[0].y + ends[1].y) / 2;
  const left = Math.min(ends[0].x, ends[1].x);
  const right = Math.max(ends[0].x, ends[1].x);
  return (obstacle) => {
    if (obstacle.kind !== "flow" || obstacle.segment === void 0) return false;
    if (obstacle.box.height > 2 * edgeInk + 0.5) return false;
    if (Math.abs(obstacle.box.y + obstacle.box.height / 2 - y) > 0.5) return false;
    return obstacle.box.x < right && obstacle.box.x + obstacle.box.width > left;
  };
}
__name(alongOwnLine, "alongOwnLine");
function tracksOf(lines, position, ends, horizontal) {
  const { labelGap, lineHeight, flowLabelPadding } = import_geometry.bpmnMetrics;
  const [from, to] = ends;
  const width = (0, import_geometry.textBlockWidth)(lines);
  const rise = (lines.length - 1) * lineHeight;
  const tracks = [];
  if (horizontal) {
    const y = (from.y + to.y) / 2;
    const left = Math.min(from.x, to.x);
    const right = Math.max(from.x, to.x);
    const span = { from: left + flowLabelPadding + width / 2, to: right - flowLabelPadding - width / 2 };
    for (let step = 0; step < 3; step++) {
      for (const baseline of [y - labelGap - step * lineHeight, y + labelGap + import_geometry.labelAscent + rise + step * lineHeight]) {
        tracks.push({ at: /* @__PURE__ */ __name((x2) => ({ x: x2, y: baseline }), "at"), preferred: position.x, along: "x", ...span });
      }
    }
    return tracks;
  }
  const x = (from.x + to.x) / 2;
  const top = Math.min(from.y, to.y);
  const bottom = Math.max(from.y, to.y);
  const baselineOf = /* @__PURE__ */ __name((center) => center + rise / 2 + (import_geometry.labelAscent - import_geometry.labelDescent) / 2, "baselineOf");
  for (let away = 0; away < 4; away++) {
    const offset = flowLabelPadding + width / 2 + away * lineHeight;
    for (const side of [x + offset, x - offset]) {
      tracks.push({
        at: /* @__PURE__ */ __name((center) => ({ x: side, y: baselineOf(center) }), "at"),
        preferred: (top + bottom) / 2,
        from: top,
        to: bottom,
        along: "y"
      });
    }
  }
  return tracks;
}
__name(tracksOf, "tracksOf");
function wrappings(lines) {
  const words = lines.join(" ").split(" ").filter((word) => word.length > 0);
  const variants = [lines];
  for (let count = lines.length + 1; count <= words.length && variants.length < 4; count++) {
    variants.push((0, import_geometry.splitIntoLines)(words, count));
  }
  return variants;
}
__name(wrappings, "wrappings");
function freePointOn(track, lines, obstacles, bounds) {
  const { labelClearance } = import_geometry.bpmnMetrics;
  const box = (0, import_geometry.boxUnion)((0, import_geometry.labelLineBoxes)(lines, track.at(track.preferred)));
  if (box === void 0) return void 0;
  const alongX = track.along === "x";
  const size = alongX ? box.width : box.height;
  const limit = alongX ? { from: bounds.x + size / 2, to: bounds.x + bounds.width - size / 2 } : { from: bounds.y + size / 2, to: bounds.y + bounds.height - size / 2 };
  const from = Math.max(track.from, limit.from);
  const to = Math.min(track.to, limit.to);
  if (from > to) return void 0;
  const across = alongX ? { from: box.y - labelClearance, to: box.y + box.height + labelClearance } : { from: box.x - labelClearance, to: box.x + box.width + labelClearance };
  const blocked = [];
  for (const obstacle of obstacles) {
    const other = obstacle.box;
    const otherAcross = alongX ? { from: other.y, to: other.y + other.height } : { from: other.x, to: other.x + other.width };
    if (otherAcross.from >= across.to || otherAcross.to <= across.from) continue;
    const otherAlong = alongX ? { from: other.x, to: other.x + other.width } : { from: other.y, to: other.y + other.height };
    blocked.push({
      from: otherAlong.from - size / 2 - labelClearance,
      to: otherAlong.to + size / 2 + labelClearance
    });
  }
  const free = /* @__PURE__ */ __name((value) => !blocked.some((b) => value > b.from && value < b.to), "free");
  const wanted = Math.min(Math.max(track.preferred, from), to);
  const options = [wanted, ...blocked.flatMap((b) => [b.from - 1e-9, b.to + 1e-9])].filter((value) => value >= from && value <= to && free(value)).sort((a, b) => Math.abs(a - wanted) - Math.abs(b - wanted) || a - b);
  return options[0];
}
__name(freePointOn, "freePointOn");
function boundsOf(layout, position) {
  const inner = /* @__PURE__ */ __name((frame) => ({
    x: frame.x + frame.headerWidth,
    y: frame.y,
    width: frame.width - frame.headerWidth,
    height: frame.height
  }), "inner");
  const holds = /* @__PURE__ */ __name((box) => position.x >= box.x && position.x <= box.x + box.width && position.y >= box.y && position.y <= box.y + box.height, "holds");
  const lane = layout.lanes.map(inner).find(holds);
  if (lane !== void 0) return lane;
  return layout.pools.map(inner).find(holds);
}
__name(boundsOf, "boundsOf");
function penaltyOf(boxes, obstacles, bounds) {
  const { labelClearance } = import_geometry.bpmnMetrics;
  let penalty = 0;
  for (const box of boxes) {
    if (!(0, import_geometry.boxContains)(bounds, box)) {
      const outside = Math.max(0, bounds.x - box.x) + Math.max(0, box.x + box.width - bounds.x - bounds.width) + Math.max(0, bounds.y - box.y) + Math.max(0, box.y + box.height - bounds.y - bounds.height);
      penalty += 1e3 * (1 + outside);
    }
    for (const obstacle of obstacles) {
      penalty += (0, import_geometry.overlapArea)(box, obstacle.box, labelClearance);
    }
  }
  return penalty;
}
__name(penaltyOf, "penaltyOf");
function placeBpmnLabels(layout) {
  const fixed = staticObstacles(layout);
  const placed = [];
  const picture = { x: 0, y: 0, width: layout.width, height: layout.height };
  for (const label of edgeLabels(layout)) {
    const ends = [label.edge.points[label.anchor], label.edge.points[label.anchor + 1]];
    const horizontal = Math.abs(ends[1].y - ends[0].y) <= Math.abs(ends[1].x - ends[0].x);
    const own = alongOwnLine(ends, horizontal);
    const obstacles = [...fixed.filter((o) => !own(o)), ...placed];
    const band = horizontal ? boundsOf(layout, label.position) : void 0;
    const bounds = band !== void 0 ? intersection(band, picture) : picture;
    let best;
    for (const lines of wrappings(label.lines)) {
      for (const track of tracksOf(lines, label.position, ends, horizontal)) {
        const free = freePointOn(track, lines, obstacles, bounds);
        if (free !== void 0) {
          const position2 = track.at(free);
          best = { position: position2, lines, boxes: (0, import_geometry.labelLineBoxes)(lines, position2), penalty: 0 };
          break;
        }
        const position = track.at(track.preferred);
        const boxes = (0, import_geometry.labelLineBoxes)(lines, position);
        const penalty = penaltyOf(boxes, obstacles, bounds);
        if (best === void 0 || penalty < best.penalty) best = { position, lines, boxes, penalty };
      }
      if (best?.penalty === 0) break;
    }
    if (best === void 0) continue;
    label.edge.labelPosition = best.position;
    label.edge.labelLines = best.lines.length > 1 ? best.lines : void 0;
    for (const box of best.boxes) placed.push({ kind: "flowLabel", id: label.flow, box });
  }
  grow(layout, placed);
}
__name(placeBpmnLabels, "placeBpmnLabels");
function intersection(a, b) {
  const x = Math.max(a.x, b.x);
  const y = Math.max(a.y, b.y);
  return {
    x,
    y,
    width: Math.max(0, Math.min(a.x + a.width, b.x + b.width) - x),
    height: Math.max(0, Math.min(a.y + a.height, b.y + b.height) - y)
  };
}
__name(intersection, "intersection");
function grow(layout, placed) {
  const { padding } = import_geometry.bpmnMetrics;
  for (const { box } of placed) {
    layout.width = Math.max(layout.width, box.x + box.width + padding);
    layout.height = Math.max(layout.height, box.y + box.height + padding);
  }
}
__name(grow, "grow");
function findBpmnLabelCollisions(layout) {
  const { labelClearance } = import_geometry.bpmnMetrics;
  const obstacles = bpmnLabelObstacles(layout);
  const collisions = [];
  for (const label of edgeLabels(layout)) {
    const ends = [label.edge.points[label.anchor], label.edge.points[label.anchor + 1]];
    const horizontal = Math.abs(ends[1].y - ends[0].y) <= Math.abs(ends[1].x - ends[0].x);
    const own = alongOwnLine(ends, horizontal);
    for (const box of (0, import_geometry.labelLineBoxes)(label.lines, label.position)) {
      for (const obstacle of obstacles) {
        if (obstacle.kind === "flowLabel" && obstacle.id === label.flow) continue;
        if (own(obstacle)) continue;
        if (!(0, import_geometry.boxesOverlap)(box, obstacle.box, labelClearance)) continue;
        if (collisions.some((c) => c.flow === label.flow && c.kind === obstacle.kind && c.id === obstacle.id)) continue;
        collisions.push({ flow: label.flow, label: label.label, kind: obstacle.kind, id: obstacle.id });
      }
    }
  }
  return collisions;
}
__name(findBpmnLabelCollisions, "findBpmnLabelCollisions");
//# sourceMappingURL=labels.js.map
